(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gr-product-tabs')) {
    customElements.define('gr-product-tabs', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.init());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.events?.abort();
      }
      init() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.tabs = Array.from(this.querySelectorAll('[data-grpt-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-grpt-panel]'));
        if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
        this.querySelector('.grpt-nav').setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', () => this.select(index), options);
          tab.addEventListener('keydown', event => {
            const rtl = getComputedStyle(this).direction === 'rtl';
            let next;
            if (event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
            if (event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            next = (next + this.tabs.length) % this.tabs.length;
            this.select(next);
            this.tabs[next].focus({ preventScroll: true });
          }, options);
        });
        this.select(this.activeIndex ?? 0);
        this.classList.add('is-ready');
      }
      select(index) {
        this.activeIndex = index;
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          this.panels[i].hidden = i !== index;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
